var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bea6163356de033d8c5d717bf648cff01d7f38e2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["timeneye-frontend@timeneye"]={id:"bea6163356de033d8c5d717bf648cff01d7f38e2"};
      